import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { apiURL,INIT_INPUT_STD_VALUES,INIT_DOCUMENTS_VALUES } from "../config/common";

export default function Scholarship() {

  let app = ApplicantContainer.useContainer();

  const [loading, setLoading] = React.useState(true);
  const [items, setItems] = React.useState([]);
  React.useEffect(() => {
    let unmounted = false;
    async function getScholarships() {
      const response = await fetch(
        apiURL + "/scholarships-e"
      );
      const body = await response.json();
      if (!unmounted) {
      
        setItems(
          body
        );
        
        setLoading(false);
      }
    }
    getScholarships();
    return () => {
      unmounted = true;
    };
  }, []);

  function ScholarshipAction(e) {

    app.inStdValues.frProgramme = '';
    app.inStdValues.frIntake='';
    
    app.onChangeInStdValues({...app.inStdValues, [e.target.id]:e.target.value});
    
    if(e.target.value === null || e.target.value === "") {    


      app.inStdValues = INIT_INPUT_STD_VALUES;
      app.inStdValues.frQualification = [{highest: true, qualification: '', grade: ''}];
      
      app.inStdValues.frParentGuardian = {frCCParentChoiceOne: '', frCCParentNameOne: '', frCCParentICPasportOne: '', frParentCCAgeOne: '', frCCParentStatusOne: '', 
                                          frCCParentEmployTypeOne: '', frCCParentOccupationOne: '', frCCParentWorkAddrOne: '', frCCParentIncomeOne: '', frCCParentOtherIncomeOne: '',                    
                                          frCCParentChoiceTwo: '', frCCParentNameTwo: '', frCCParentICPasportTwo: '', frParentCCAgeTwo: '', frCCParentStatusTwo: '', 
                                          frCCParentEmployTypeTwo: '', frCCParentOccupationTwo: '', frCCParentWorkAddrTwo: '', frCCParentIncomeTwo: '', frCCParentOtherIncomeTwo: ''};                                          
      app.inStdValues.frSiblingStudy = [{SiblingName: '', Gender: '', Age: '', NameOfSchool: '', SrcFinSupport: '' }];
      app.inStdValues.frSiblingWorking = [{SiblingName: '', Gender: '', Age: '', Occupation: '', Income: '' }];
      app.inStdValues.frCommunityCareInfo = {frCCHome: '', frCCAddr: '', frCCLeaderName: '', frCCPosition: '', frCCTel: '', frCCMobile: '', frCCEmail: ''};
      
      app.inStdValues.frExtracurricularLeadership = [{ LeaderYear: '', LeaderName: '', LeaderPosition: '' }];
      app.inStdValues.frExtracurricularCompete = [{ CompeteYear: '', CompeteName: '', CompeteResult: '' }];
      app.inStdValues.frExtracurricularAward = [{ AwardYear: '', AwardName: '' }];
      app.inStdValues.frExtracurricularOther = [{ AwardYear: '', AwardName: '' }];
      app.inStdValues.frMusic = [{ InstrumentPlayed: '', MusicGrade: '' }];
      app.inStdValues.frContactReferee = [{ sname: '', affiliation: '', position: '', email: '' }];
      app.inStdValues.frSports = [{ SportLevel: '', SportType: '', SportPeriod: '', SportRemark: '' }];
      app.onChangeInStdValues(INIT_INPUT_STD_VALUES);

      app.setShowParentGuardian(false); 
      app.onChangeDocuments(INIT_DOCUMENTS_VALUES);

      

      

      
    }
    
    getProgramme(e);

    getSchRegStatus(e);
    
    ResetScholarshipSection();

    switch(e.currentTarget.value){
      case "YOUNG CHEF":
      case "HOTELIER":
          app.setShowEssay(true);
          app.setOtherInfoHeader2("ESSAY");
          app.setOtherInfoHeader("");
          app.setScholarshipType("mix");
        break;
        case "SITI HASMA":         
        case "SUN MUSIC":
        case "MUSIC":
          app.setShowMusicBackground(true); 
          app.setOtherInfoHeader2("MUSIC BACKGROUND (If you play more than one instrument, please indicate both instruments' details.)"); 
          app.setOtherInfoHeader("");
          app.setScholarshipType("mix");
        break;
        case "SPORTS":
          app.setShowSports(true);  
          app.setOtherInfoHeader2("SPORTS PARTICIPATION AND ACHIEVEMENT INFORMATION"); 
          app.setOtherInfoHeader("");
          app.setScholarshipType("local");
        break;     
        case "SVUMS":
        case "EXCELLENCE":
        case "VU EX":
        case "ASU":
        case "CHANCELLOR":
          app.setShowExtracurricular(true);
          app.setOtherInfoHeader2("EXTRACURRICULAR ACTIVITIES"); 
          app.setOtherInfoHeader("");
          app.setScholarshipType("local");
        break;
        case "JCF":
        case "COMMUNITY":
          app.setShowExtracurricular(true);
          app.setOtherInfoHeader2("EXTRACURRICULAR ACTIVITIES");
          app.setShowFamilyBackground(true);
          app.setShowCommunityCC(true);
          app.setOtherInfoHeader("FAMILY BACKGROUND");
          app.setScholarshipType("local");
          break; 
        // case "COMMUNITY":
        //   app.setShowFamilyBackground(true);
        //   app.setShowCommunityCC(true);
        //   app.setOtherInfoHeader("FAMILY BACKGROUND"); 
        //   app.setScholarshipType("local");
        break;
        case "SHSM":
          app.setShowContactReferee(true);
          app.setOtherInfoHeader2("CONTACT OF REFEREE");
          app.setOtherInfoHeader("");
          app.setScholarshipType("mix");
        break;
        case "TSDSDJC":
        case "TAUGHT":
        case "ART":
        case "FASHION":
        case "SUNWAY TES":
        case "DOC MERIT":
          app.setOtherInfoHeader("");
          app.setScholarshipType("mix");
          app.setOtherInfoHeader2("");
          // app.setShowSchRegisterStatus(true);
        break;
        case "BURSARY":
        case "DIP BUR":
          app.setOtherInfoHeader("");
          app.setOtherInfoHeader2("");
          app.setScholarshipType("int");
        break;
      default:
        app.setOtherInfoHeader("");
        app.setOtherInfoHeader2("");
        app.setScholarshipType("local");
    }    
  };

  function ResetScholarshipSection() {
    app.setShowEssay(false);
    app.setShowContactReferee(false);
    app.setShowSports(false);
    app.setShowMusicBackground(false);
    app.setShowExtracurricular(false);
    app.setShowFamilyBackground(false);    
    app.setShowCommunityCC(false);
    app.setShowSupportingDocuments(false);

    app.setScholarshipType("");

    // app.setShowSchRegisterStatus(false);
      
    app.setError([]);
    app.setValidate(false);

  }

  function getProgramme(e) {    

    if(e.target.value === null || e.target.value === "") {    
      app.setProgrammeOffer([]);
      app.setprogrammmeChosen('');
      app.setIntakesNoOffer([]);
      app.setIntakeNoChosen('');   
      app.setScholarshopChosen('');
    }
     else  {
      app.setScholarshopChosen(e.target.value);

      fetch(apiURL + "/programmes-e",{
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ "scholarshipChosen": e.target.value })
      })
      .then(res => res.json())
      .then(
          (result) => {
            app.setProgrammeOfferLoad(true);
            app.setProgrammeOffer([]);
            app.setProgrammeOffer(result);
            app.setIntakesNoOffer([]);
            app.setprogrammmeChosen('');
            app.setIntakeNoChosen('');
            
          },
          (error) => {
            //console.log(error);
          }
      )
  }

    
  }

  function getSchRegStatus(e){

    fetch(apiURL + "/scholarshipregstatus-e",{
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ "scholarshipChosen": e.target.value })
    })
    .then(res => res.json())
    .then(
        (result) => {
          app.setShowSchRegisterStatus(result);
        },
        (error) => {
          // console.log(error);
        }
    )

  }


  return (
    <>
    <Form.Row>
      <Col xs={12}>        
          <Form.Group as={Col} controlId="frScholarship" htmlFor="frScholarship">
          <Form.Label>Scholarship</Form.Label>      
          <Form.Control required as="select"   
          disabled={loading}
          value={app.inStdValues.frScholarship}
          onChange={(e) => {ScholarshipAction(e)}} >
          <option key="" value="">
              --- SELECT A SCHOLARSHIP --- 
            </option>
          {items.map((item) => 
            <option key={item.SCHOLARSHIP_ID} value={item.SCHOLARSHIP_ID}>
              {item.SCHOLARSHIP_NAME}
            </option>
          )}
          </Form.Control>
          {app.showScholarshipType == "int" ?
          <div className='add-clause'>
            This scholarship is offering to the registered international students only. Please refer to Sunway International Office for the scholarship criteria before submit the scholarship application.
          </div>
          : app.showScholarshipType == "mix" ?
          <div className='add-clause'>
            For international students, please refer to the Sunway International Office for the scholarship criteria before proceed with the scholarship submission.
          </div>
          :
          ""}
          </Form.Group>
      </Col>
    </Form.Row>
    </>
  );

}